import { useState } from 'react';
import { useSelector } from 'react-redux';
import StripWidget from '../../../../shared/components/features/widget/stripWidget/StripWidget';
import PencilCaseMobilePopup from './pencilCaseMobilePopup/PencilCaseMobilePopup';
import pencilCaseImg from '../../../../assests/classroomApplets/pencilCase.png';
import classes from './MobileAppletsWidget.module.css';

const MobileAppletsWidget = () => {

  const { texts } = useSelector(state => state.translate);
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  return (
    <>
      <StripWidget
        className={classes.Strip}
        image={pencilCaseImg}
        title={texts.myPencilCase}
        text={texts.newInVirtualSchool}
        classNameText={classes.MobileTeaser}
        onClick={() => setShowMobilePopup(true)}
      />
      {showMobilePopup &&
        <PencilCaseMobilePopup onClose={() => setShowMobilePopup(false)} />
      }
    </>
  );
};

export default MobileAppletsWidget;
